import { makeStyles } from 'tss-react/mui'
import { primary, red, white } from '../../assets/colors'


export const useStyles = makeStyles()((theme) => {
    return {
        table: {
            tableLayout: "fixed",
            border: 0
        },
        tableRow: {
            border: 'none'
        },
        headerCell: {
            padding: '2px',
            color: theme.palette.text.disabled,
            textAlign: 'right',
            border: 0,
            '&:first-of-type': {
                textAlign: 'left'
            }
        },

        rowCell: {
            padding: '2px',
            textAlign: 'right',
            fontSize: '13px',
            border: 0,
            fontFeatureSettings: "'tnum' on, 'lnum' on",
            '&:first-of-type': {
                textAlign: 'left'
            }
        },
        bidCell: {
            color: primary
        },
        askCell: {
            color: red
        },
        tradeable: {
            cursor: "pointer",

            '&: hover td': {
                color: 'unset'
            }
        }
    }
})